import { Stack } from '@mui/material';
import { PageShell } from '@/shared/ui/PageShell';
import { SectionHeader } from '@/shared/ui/SectionHeader';
import { EmptyState } from '@/shared/ui/EmptyState';

export function GuestMyRequestsPage() {
  return (
    <PageShell>
      <Stack spacing={4}>
        <SectionHeader>My Requests</SectionHeader>
        {/* TODO Phase 3: fetch GET /events/:eventCode/my-requests and render list */}
        <EmptyState title="No song requests yet." description="Send the DJ your first request." />
      </Stack>
    </PageShell>
  );
}
